module.exports = __webpack_public_path__ + "images/emoji/heartbeat.163713b06404ca25bc08.png";